const url = encodeURIComponent(window.location.href)

export const shareUrls = {
  facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
  telegram: `https://t.me/share/url?url=${url}`,
  whatsapp: `https://web.whatsapp.com/send?text=${url}`,
  twitter: `https://twitter.com/share?text=${document.title}&url=${url}`,
  vk: `http://vk.com/share.php?url=${url}`,
  email: `mailto:?body=${url}&subject=${document.title}`,
  odnoklassniki: `https://connect.ok.ru/offer?url=${url}`,
}
